const AZ_SP_BOOKING_BASE = 'https://azstateparks.com/reserve/';

/**
 * Arizona State Parks (Tyler/Keechma) park deeplink.
 * #!park/{placeId} lists that park's loops. #!park/{placeId}/{facilityId}
 * opens one loop's site grid. The site ignores arrival date and nights.
 */
export function buildArizonaSpBookingUrl({ placeId, facilityId } = {}) {
  if (placeId == null || placeId === '') return AZ_SP_BOOKING_BASE;
  const facility =
    facilityId != null && facilityId !== '' ? `/${facilityId}` : '';
  return `${AZ_SP_BOOKING_BASE}#!park/${placeId}${facility}`;
}

export function buildArizonaSpBookingUrlForOuting({ outing } = {}) {
  if (!outing) return AZ_SP_BOOKING_BASE;
  const isTour =
    outing.entity_type === 'permit' || outing.metadata?.kind === 'tour';
  if (isTour) {
    return 'https://azstateparks.com/reserve/Activities/ProgramsAndTours.aspx';
  }
  return buildArizonaSpBookingUrl({
    placeId: outing.metadata?.placeId ?? outing.parent_id,
  });
}
